export default {

	loader:false,
	
}